<template>
  <main class="digital-voucher">
    <template v-if="extension.payload && extension.payload.item_name">
      <section class="digital-voucher-row">
        <div class="offer offer-name">
          <div class="offer-label">offer name</div>
          <div class="offer-value">{{ extension.payload.item_name }}</div>
        </div>
        <div class="offer expiration">
          <div class="offer-label">expiration</div>
          <div class="offer-value">{{ expirationDate }} (midnight)</div>
        </div>
      </section>

      <section class="digital-voucher-row">
        <div class="offer uses-per-customer">
          <div class="offer-label">uses per customer</div>
          <div class="offer-value">{{ usesPerCustomer }}</div>
        </div>
        <div class="offer display-image">
          <div class="offer-label">display image</div>
          <div class="offer-value">{{ hasDisplayImage }}</div>
        </div>
        <div class="offer voucher-image">
          <div class="offer-label">voucher image</div>
          <div class="offer-value">{{ hasVoucherImage }}</div>
        </div>
      </section>
    </template>
  </main>
</template>

<script>
import { utcToZonedTime } from "date-fns-tz";
import { format } from "date-fns";
import { mapGetters } from "vuex";

export default {
  props: {
    extension: Object
  },

  name: "digital-voucher-preview",

  computed: {
    expirationDate() {
      const expirationDate = this.extension.payload?.expiration_date;
      return expirationDate ? format(utcToZonedTime(expirationDate, this.merchantTimeZone), "MM/dd/y") : null;
    },
    hasDisplayImage(){
      const displayImage = this.extension.payload?.has_preload_image;
      return displayImage ? "yes" : "no";
    },
    hasVoucherImage(){
      const voucherImage = this.extension.payload?.has_coupon_image;
      return voucherImage ? "yes" : "no";
    },
    usesPerCustomer() {
      const maxRedemptions = this.extension.payload?.max_redemptions;
      return (Number(maxRedemptions) === -1) ? "unlimited" : maxRedemptions;
    },
    ...mapGetters(["merchantTimeZone"])
  }
}
</script>

<style scoped>
.digital-voucher {
  width: 100%;
}

.offer {
  padding: 5px 6px;
}

.offer:not(:last-child){
  border-right: 1px solid #128ff9;
}

.digital-voucher .offer-label {
  color: gray;
  font-size: .8em;
}

.digital-voucher .offer-value {
  font-size: .9em;
}

.digital-voucher-row {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
}

.digital-voucher-row > * {
  flex-grow: 1;
}

.digital-voucher-row:first-child {
  border-bottom: 1px solid #128ff9;
}
</style>
